
import { Component, Mixins, Prop } from "vue-property-decorator";
import { DataModules } from "@/store/modules/data";
import { ITemplate } from "@/models/templates";
import { UpmindObjectTypes } from "@/data/enums/objects";
import AdminBrandId from "@/mixins/adminBrandId";
import { IClient } from "@/models/clients";
import { IUser } from "@/models/users";
import { CreateElement } from "vue";
import { UpmindObjectToDataModuleMapping } from "@/data/enums/objects";
import InvoicesListing from "@/components/app/global/invoices/invoicesListing.vue";
import CProdsListing from "@/components/app/global/contractProducts/cProdsListing.vue";
import ClientSearch from "@/components/app/global/client/clientSearch.vue";
import { IdParam } from "@/data/filters/client";
import {
  ClientsIdParam,
  DefaultCProdFilters
} from "@/data/filters/contractProducts";
import { DefaultCProdSorters } from "@/data/sorters/contractProducts";
import { ListDisplayMode } from "@/data/constants";
import { IContractProduct } from "@/models/contracts";

@Component
export default class SendTestEmailObjectSelectModal extends Mixins(
  AdminBrandId
) {
  // Props

  @Prop({ required: true })
  public template!: ITemplate;

  @Prop({ required: true })
  public objectType!: UpmindObjectTypes;

  @Prop({ default: null })
  public client!: IClient;

  @Prop({ default: null })
  public user!: IUser;

  // Methods

  public renderClientSearch(h: CreateElement) {
    return h(ClientSearch, {
      props: {
        id: this.template.id,
        dataScope: `$${this.template.id}_select_object`,
        brandId: this.brandId,
        limit: 8,
        onSelect: (client: IClient) =>
          this.$emit("success", {
            object: client,
            objectId: client.id,
            email: client.email
          }),
        showGuestsToggle: false,
        manualFilters: this.client ? { ...IdParam(this.client?.id) } : {}
      }
    });
  }

  public renderInvoices(h: CreateElement) {
    return h(InvoicesListing, {
      props: {
        id: this.template.id,
        dataScope: `$${this.template.id}_select_object`,
        clientId: this.client?.id
      },
      attrs: {
        rowProps: () => ({}),
        rowEvents: invoice => ({
          click: () =>
            this.$emit("success", { object: invoice, objectId: invoice.id })
        })
      }
    });
  }

  public renderCProds(h: CreateElement) {
    return h(CProdsListing, {
      props: {
        id: this.template.id,
        dataScope: `$${this.template.id}_select_object`,
        availableFilters: DefaultCProdFilters,
        availableSorters: DefaultCProdSorters,
        parentFilters: this.client
          ? { ...ClientsIdParam({ clientId: this.client.id }) }
          : {},
        rowTag: "tr",
        forceDisplayMode: ListDisplayMode.TABLE,
        rowEvents: (cprod: IContractProduct) => ({
          click: () =>
            this.$emit("success", { object: cprod, objectId: cprod.id })
        })
      }
    });
  }

  public renderObjectView(h: CreateElement) {
    switch (UpmindObjectToDataModuleMapping[this.objectType]) {
      case DataModules.INVOICES:
        return this.renderInvoices(h);
      case DataModules.CLIENTS:
        return this.renderClientSearch(h);
      case DataModules.CONTRACTS_PRODUCTS:
        return this.renderCProds(h);
    }
  }

  public render(h: CreateElement) {
    return h(
      "modal-card",
      {
        props: { title: this.$t("_sentence.templates.select_email_object") },
        on: { close: () => this.$emit("close") }
      },
      [this.renderObjectView(h)]
    );
  }
}
